import React from 'react';
import styles from './SalesSuggestions.module.scss';
import { Container, Row } from 'reactstrap';

const suggestionsList = [
    {
        text: "Optimize Your Product Listings",
        subItems: [
            "Ensure your product descriptions are detailed and include relevant keywords.",
            "Use high-quality images and videos to showcase your products."
        ],
    },
    {
        text: "Improve Customer Engagement",
        subItems: [
            "Implement a loyalty program to reward repeat customers.",
            "Use email marketing to keep your customers informed about new products and promotions."
        ],
    },
    {
        text: "Enhance Your Promotions",
        subItems: [
            "Experiment with different types of promotions such as flash sales, bundle deals, and seasonal discounts.",
            "Use A/B testing to determine the most effective promotion strategies."
        ],
    },
    {
        text: "Increase Traffic",
        subItems: [
            "Invest in search engine optimization (SEO) to improve your store’s visibility.",
            "Leverage social media marketing to reach a broader audience."
        ],
    },
    {
        text: "Boost Conversion Rates",
        subItems: [
            "Simplify the checkout process to reduce cart abandonment.",
            "Provide multiple payment options to cater to a wider range of customers."
        ],
    },
    {
        text: "Focus on Customer Reviews",
        subItems: [
            "Encourage satisfied customers to leave positive reviews.",
            "Address any negative feedback promptly to show that you care about customer satisfaction."
        ],
    },
];

const SalesSuggestions = () => {
    return (
        <div className={styles.mainContainer}>
            <Container fluid className={styles.suggestionSection}>
                <div className={styles.sectionTitle}>
                    <h5 className={styles.sectionSubHeading}>Suggestions to Increase Sales</h5>
                </div>

                <div className={styles.suggestionDataWrapper}>
                    <Row className={styles.suggestionDataRow}>
                        <p>Based on your current performance, here are some tailored suggestions to help increase your sales:</p>
                        <ol>
                            {suggestionsList.map((item, index) => (
                                <li key={index} className={styles.orderedList}>
                                    {item.text}:
                                    <ul>
                                        {item.subItems.map((subItem, subIndex) => (
                                            <li key={subIndex}>{subItem}</li>
                                        ))}
                                    </ul>
                                </li>
                            ))}
                        </ol>
                    </Row>
                </div>
            </Container>
        </div>
    )
}

export default SalesSuggestions;